module.exports = __webpack_public_path__ + "static/media/lane_geometry_icon.f64244c5.svg";